import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

export function hasBefehl21EmptyFields(befehl: Befehl): boolean {
  if (!befehl.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2110 = findAuftrag(befehl, '21.10')
  if (auftrag2110) {
    const has2211_name = hasFieldContent(
      auftrag2110,
      '21.11',
      'zugmeldestelle.name'
    )
    const has2211_art = hasFieldContent(
      auftrag2110,
      '21.11',
      'zugmeldestelle.art'
    )

    return !has2211_name || !has2211_art
  }

  return false
}
